import { createAction, props } from "@ngrx/store";
import { ReportGeneratorDto } from "../interfaces/report_generator_dto";
import { ReportConfigurationDto } from "../interfaces/report_configuration_dto";

export const upsertReport = createAction(
    "[Reports] Upsert Report",
    props<{ report: ReportGeneratorDto }>()
);

export const loadReports = createAction(
  "[Reports] Load Reports",
);

export const loadReportsSuccess = createAction(
    "[Reports] Load Reports Success",
    props<{ reports: ReportGeneratorDto[] }>()
);

export const deleteReport = createAction(
    "[Reports] Delete Report",
    props<{ report: ReportGeneratorDto }>()
);

export const deleteReportSuccess = createAction(
    "[Reports] Delete Report Success",
    props<{ report_generator_id: number }>()
)

export const loadReportConfigurations = createAction(
    "[Reports] Load Report Configuration"
)

export const loadReportConfigurationsSuccess = createAction(
    "[Reports] Load Report Configuration Success",
    props<{ reportConfigurations: ReportConfigurationDto[] }>()
)
